import i18n from '../localize/i18n'

// Libellés traduits via `businessType.<index>` (public/locales) ; ce tableau sert de repli
const TYPES = [
  'Aucun',
  'Asiatique',
  'Japonais',
  'Thailandais',
  'Chinois',
  'Italien',
  'FastFood',
  'Salon de thé',
  'Bubble tea',
  'Américain',
  'Français',
  'Sandwich',
  'Burger',
  'Vietnamien',
  'Chicken',
  'Glace',
  'Coréen',
  'Indien',
  'Volonté',
  'Halal',
  'Mexicain',
  'Pizza',
  'Sushis',
  'Brunch',
  'Healthy',
  'Salade',
  'Marocain',
  'Fruits de mer',
  'Pâtes',
  'Maison de Bao',
  'Cusine chinoise',
  'Cuisine du monde',
  'Buffet',
  'Buffet à volonté',
  'Pakistanais',
  'Orientale',
  'Végan',
  'Halal',
  'Spécialité Hawaïenne',
  'Ramen'
]

export function getBusinessTypes(arr) {
  if (arr === undefined) return ''
  let str = ''

  arr.forEach(id => {
    if (id === -1 || TYPES[id] === undefined) return
    const label = i18n.t(`businessType.${id}`, { defaultValue: TYPES[id] })
    if (str === '')
      str = str.concat('', label)
    else
      str = str.concat(' • ', label)
  });
  return str
}

export function getOrderType(type) {
  if (type === 1)
    return i18n.t('orderType.takeaway')
  if (type === 2)
    return i18n.t('orderType.eatIn')
  if (type === 3)
    return i18n.t('orderType.table')
  if (type === 4)
    return i18n.t('orderType.delivery')
}

export function parseSchedule(sc) {
  const schedule = Array(7);
  for (let i = 0; i < 7; ++i) {
    schedule[i] = [];
    if (sc && sc[i] && sc[i].dailySchedule) {
      const daySchedule = sc[i].dailySchedule;
      if (daySchedule) {
        for (let ii = 0; ii < daySchedule.length; ++ii) {
          const timeRange = daySchedule[ii].split('-');
          schedule[i].push({
            start: timeRange[0],
            end: timeRange[1],
          });
        }
      }
    }
  }

  return schedule;
}

export function computeDiscount(price, discount, getDiscountedPrice = false) {
  if (getDiscountedPrice) {
    return price * (1 - discount / 100);
  }
  return price * (discount / 100);
}

export function paymentIdToName(id) {
  switch (id) {
    case 1: return i18n.t('payment.cash');
    case 2: return i18n.t('payment.card');
    case 3: return i18n.t('payment.mealVoucher');
    case 4: return i18n.t('payment.cheque');
    case 5: return i18n.t('payment.holidayVoucher');
    case 6: return i18n.t('payment.credit');
    case 7: return i18n.t('payment.other');
    case 8: return i18n.t('payment.online');
    case 9: return i18n.t('payment.twint');
    default: return '?';
  }
}

export function convertFirebaseUrlToCustomDomain(url, customDomain = 'https://cdn.we-eats.com') {

  // Extract the path and filename from the Firebase URL
  const regex = /\/o\/(.*?)/;
  const match = url.match(regex);

  if (match && match[1]) {
    // Decode the URL-encoded path
    const filePath = decodeURIComponent(match[1]);

    // Construct the new URL using the custom domain
    const newUrl = `${customDomain}/${filePath}?alt=media`;
    return newUrl;
  } else {
    return url
  }
}

// symbol vide = devise masquée (réglage backoffice showCurrencyOnOrder)
export function formatCurrency(amount, symbol = '€') {
  return symbol ? `${amount.toFixed(2)} ${symbol}` : amount.toFixed(2);
}